export default {
      id: "notifications__movement-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#notifications__movement",
      toString: function () {
        return this.url;
      }
    }